/**
 * @prettier
 * @author Alexander Nagelberg
 *
 **/
import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import Authorize from 'app/components/Authorize'
import RefundProcessingContainer from '../containers/RefundProcessingContainer'
import RefundRecordContainer from '../containers/RefundRecordContainer'
import RefundSearchContainer from '../containers/RefundSearchContainer'
import RefundNoteContainer from '../containers/RefundNoteContainer'
import ReportContainer from '../containers/ReportContainer'
import { URLs } from '../utils/refundUtils'

const FundingFeeBody = () => (
  <div className='lgy-funding-fee-body usa-width-three-fourths lgy-funding-fee-body'>
    <Switch>
      <Route exact path={URLs.FUNDING_FEE_REFUND_APP_PATH}>
        <Redirect to='/lgyhub/funding-fee/refunds/processing' />
      </Route>
      <Route exact path={`${URLs.FUNDING_FEE_REFUND_APP_PATH}/processing`}>
        <Authorize gearAuth={['View Funding Fee Refund Record']} gearName='Funding Fee Refunds'>
          <RefundProcessingContainer />
        </Authorize>
      </Route>
      <Route exact path={`${URLs.FUNDING_FEE_REFUND_APP_PATH}/search`}>
        <Authorize gearAuth={['View Funding Fee Refund Record']} gearName='Funding Fee Refunds'>
          <RefundSearchContainer />
        </Authorize>
      </Route>
      <Route exact path={`${URLs.FUNDING_FEE_REFUND_APP_PATH}/:id`}>
        <Authorize
          gearAuth={['View Funding Fee Refund Record', 'Edit Funding Fee Refund Record']}
          gearName='Funding Fee Refunds'
        >
          <RefundRecordContainer />
        </Authorize>
      </Route>
      <Route exact path={`${URLs.FUNDING_FEE_REFUND_APP_PATH}/report/:action`}>
        <Authorize
          gearAuth={['Generate Funding Fee Refund Pre-Screen Report', 'Generate Funding Fee Refund Payment']}
          gearName='Funding Fee Refunds'
        >
          <ReportContainer />
        </Authorize>
      </Route>
      <Route exact path={`${URLs.FUNDING_FEE_REFUND_APP_PATH}/:refundId/note`}>
        <Redirect to={`note/new`} />
      </Route>
      <Route exact path={`${URLs.FUNDING_FEE_REFUND_APP_PATH}/:refundId/note/:noteId`}>
        <Authorize gearAuth={['View Funding Fee Refund Record']} gearName='Funding Fee Refunds'>
          <RefundNoteContainer />
        </Authorize>
      </Route>
    </Switch>
  </div>
)

export default FundingFeeBody
